export default {
    /* Global Vocabulary */
    validations: {
        is_required: '"{field_name}" is required.',
        invalid: '"{field_name}" is invalid',
        this_field_is_required: 'This field is required.',
        field_is_copied: '{field} is copied!',
    },
    address: 'Address',
    of: 'of',
    got_it: 'Got it',
    attach_file: 'Attach file',
    take_photo: 'Take photo',
    confirm: 'Confirm',
    ok: 'OK',
    copy: 'Copy',
    new: 'New',
    site_title: 'Rebit',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    search: 'Search',
    total: 'Total',
    click_to_confirm: 'Click to confirm',
    complete: 'Complete',
    currency: 'Currency',
    send: 'Send',
    sending: 'Sending',
    id_document: 'ID Document',
    submitting: 'Submitting',
    ideas: 'Ideas',
    update: 'Update',
    errors: {
        error_500: 'Server Error',
        too_many_requests: 'Too many requests.',
        an_error_has_occurred: 'An error has occurred!',
        something_went_wrong: 'Something went wrong!',
        please_try_again_or_contact_rebit_support: 'Please try again or contact Rebit Support.'
    },
    app: {
        notifications: {
            category_notification_updated: '{category} updated!',
        },
    },
    please_try_again_another_day: 'Please try again another day!',
    /* Module special vocabulary */
    dashboard: {
        menu: {
            index: 'Dashboard'
        },

        users_count: 'Users Count',
    },
    content_aware_bar: {
        action_required: 'ACTION REQUIRED!\n',
        verify_now: 'Verify now',
        payment_issue: 'Payment issue!',
        follow_up: 'Follow up',
        awaiting_payment_approval: 'Awaiting payment approval!',
        pay_now: 'Pay now',
        resolve_issue: 'Resolve issue'
    },
    feature_dialog: {
        any_ideas_or_suggestions: 'Any ideas or suggestions?',
        got_an_idea_for_a_cool_new_feature: 'Got an idea for a cool new feature or a way to make things better? Share your thoughts with us. Selected ideas will be rewarded.',
        let_us_know_how_we_can_improve_rebit: 'Let us know, how we can improve Rebit!',
        screenshots: 'ScreenShots'
    },
    'super-admin':'Super Admin',
    admin: 'Admin',
    user: 'User',
    version: 'Version',
    roles: {
        'super-admin': 'super-admin',
        admin: 'admin',
        user: 'user',
        assistant: 'Assistant'
    },
    loading: 'loading',
    install_dialog: {
        install_rebit_app: 'Install Rebit App?',
        yes: 'Yes',
        later: 'Later',
        never: 'Never',
        install_app_to_access_rebit_from_your_home_screen: 'Install app to access Rebit from your home screen.'
    },
    update_required_title: 'Update Required',
    update_required_message: 'Your application version is outdated. Please logout and refresh to update.',
}

